import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const EmptyState = ({ icon: Icon, title, description, actionLabel, onAction, steps, secondaryLabel, secondaryTo, testId = "empty-state" }) => (
  <div data-testid={testId} className="flex flex-col items-center justify-center rounded-xl border bg-card p-10 text-center">
    {Icon && (
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-secondary text-primary">
        <Icon className="h-6 w-6" />
      </div>
    )}
    <h3 className="h-display text-lg font-semibold text-foreground">{title}</h3>
    {description && <p className="mt-1 max-w-md text-sm text-muted-foreground">{description}</p>}
    {steps?.length > 0 && (
      <ol className="mt-5 w-full max-w-md space-y-2 text-left" data-testid={`${testId}-steps`}>
        {steps.map((step, i) => (
          <li key={step} className="flex items-start gap-3 rounded-lg bg-secondary/60 px-3 py-2 text-sm text-foreground" data-testid={`${testId}-step-${i}`}>
            <span className="ff-mono mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand text-[10px] font-bold text-brand-foreground">{i + 1}</span>
            <span>{step}</span>
          </li>
        ))}
      </ol>
    )}
    <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
      {actionLabel && <Button onClick={onAction} data-testid="empty-state-action">{actionLabel}</Button>}
      {secondaryLabel && secondaryTo && <Link to={secondaryTo} className="inline-flex items-center gap-1 text-sm font-medium text-brand-ink hover:underline" data-testid={`${testId}-secondary`}>{secondaryLabel}<ArrowRight className="h-3.5 w-3.5" /></Link>}
    </div>
  </div>
);
